export const errorMsg = {
  emptyField: 'Field can not be empty.',
  email: 'Enter correct email format.',
  password: 'Enter at least 8 digits.',
  urlCheck: 'Enter valid url.',
};
